import { CommonModule, UpperCasePipe } from '@angular/common';
import { Component, computed, inject, input, output, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiModule } from '@components/ui/ui-module';
import { CardBinder, CardCondition, Scan } from '@models/binder.model';
import { BinderService } from '@services/binder.service';
import { Global } from '@services/global.service';
import { Router } from '@services/route.service';
import { Card as CardService } from '@services/card.service';
import { Card, CardPrice, MarketPlace } from '@models/card.model';
import { forkJoin } from 'rxjs';

@Component({
  selector: 'lgb-card-item',
  imports: [
    CommonModule,
    RouterModule,
    UiModule,
    UpperCasePipe
  ],
  templateUrl: './card-item.html',
  styleUrl: './card-item.css',
})
export class CardItem {
  //service
  readonly router=inject(Router);
  readonly binderS=inject(BinderService);
  readonly cardS=inject(CardService);
  readonly globalS=inject(Global);

  //data
  readonly card=input.required<CardBinder>();
  readonly scan=input.required<Scan>();
  readonly share=input<string>(null);
  readonly admin=computed(() => this.share()==null);
  readonly reference=input.required<Card>();
  readonly lazy=input(false);
  readonly infos=input(true);
  readonly conditions=signal<CardCondition[]>([]);
  readonly backHisto=input(false);
  readonly unlike=output<boolean>();
  readonly markets=signal<MarketPlace[]>([]);
  readonly market=computed(() => this.getMarket());

  //ui
  readonly isActive=computed(() => (!this.card().scan || (this.scan() && this.scan().state=='finished')));
  readonly name=computed(() => this.cardS.getNameFeat(this.reference(), this.card().lang));

  constructor(){
    this.globalS.init()
      .subscribe(result => {
        this.conditions.set(result.conditions);
        this.markets.set(result.marketplaces);
      });
  }

  getCondition(){
    return this.conditions().find(c => c.ref==this.card().condition);
  }

  getUrl(){
    if(this.admin())
      return ((this.isActive())? this.router.parse('collect-card', [this.card().ident]) : null);
    else
      return this.router.parse('share-card', [this.card().ident]);
  }

  getQueryParams(){
    return {
      back: ((this.backHisto() && !this.share())? 'histo' : null),
      share: this.share()
    }
  }

  toggleFavoriteCard(){
    this.binderS.toggleFavoriteCard(this.card().ident)
      .subscribe(card => {
        this.card().isFavorite=card.isFavorite;

        if(!card.isFavorite)
          this.unlike.emit(true);
      });
  }

  getMarket(){
    if(this.card().price)
      return this.markets().find(m => m.ref==this.card().price.marketplace);
    else
      return null;
  }
}
